var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAstroH(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.04436 10.3683C2.41699 11.5145 2.41699 12.8971 2.41699 15.6622V17.5002C2.41699 22.2137 2.41699 24.5705 3.83264 26.0348C5.2483 27.4992 7.52674 27.4992 12.0837 27.4992H16.917C21.4739 27.4992 23.7524 27.4992 25.168 26.0348C26.5837 24.5705 26.5837 22.2137 26.5837 17.5002V15.6622C26.5837 12.8971 26.5837 11.5145 25.9563 10.3683C25.3289 9.22219 24.1828 8.51084 21.8905 7.08816L19.4738 5.58832C17.0506 4.08445 15.839 3.33252 14.5003 3.33252C13.1616 3.33252 11.95 4.08445 9.52686 5.58832L7.11019 7.08818C4.81789 8.51084 3.67173 9.22219 3.04436 10.3683ZM15.4066 14.2075C15.4066 13.707 15.0008 13.3013 14.5003 13.3013C13.9998 13.3013 13.5941 13.707 13.5941 14.2075V16.9263H10.8753C10.3748 16.9263 9.96908 17.332 9.96908 17.8325C9.96908 18.333 10.3748 18.7388 10.8753 18.7388H13.5941V21.4575C13.5941 21.958 13.9998 22.3638 14.5003 22.3638C15.0008 22.3638 15.4066 21.958 15.4066 21.4575V18.7388H18.1253C18.6258 18.7388 19.0316 18.333 19.0316 17.8325C19.0316 17.332 18.6258 16.9263 18.1253 16.9263H15.4066V14.2075Z",
    fill: "#2CB3FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAstroH);
export default __webpack_public_path__ + "static/media/astroH.db73f34937571223dd1f66fc34e638a6.svg";
export { ForwardRef as ReactComponent };